import { strings } from '@/strings';

export function AdminHome() {
  return <h1 className="text-xl font-bold text-primary">{strings.navAdminOverview}</h1>;
}
